module.exports = __webpack_public_path__ + "static/cozinha-28-n-c1c6fa9d25ecd2e20c8f4316507d0c7b.jpg";